import React from 'react'
import { mount } from '../utils/mount'
import { Footer } from '../components/footer'

mount('#footer-root', <Footer />)